import { http } from "@/http/http.js";

export default {
	// 查看发单员工单
	queryCreateOrderInfo(data) {
		return http.post("/mp/busOrder/queryCreateOrderInfo", data);
	},

	// 发单员新建工单
	addBusOrder(data) {
		return http.post("/mp/busOrder/addBusOrder", data);
	},

	// 查看项目列表
	queryBusProjectInfo(data) {
		return http.post("/mp/busOrder/queryBusProjectInfo", data);
	},

	// 发单员撤回工单
	cancelBusOrder(data) {
		return http.post("/mp/busOrder/cancelBusOrder", data);
	}
};